import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/tooltip';

@Component({
  templateUrl: './tooltip.component.html'
})
export class TooltipComponent implements OnInit {

	code = Code;
	parameters: any[];
	styleHeader: any[];
	styleValue: any[];
	headers: any[];

	constructor() { }

	ngOnInit() {
		
		this.parameters = [
			{name: "pTooltip",type: "string",default: "null",des: "工具提示文本"},
			{name: "tooltipPosition",type: "string",default: "right",des: "工具提示的位置，有效值为右、左、上、下。"},
			{name: "tooltipEvent",type: "string",default: "hover",des: "事件以显示工具提示，有效值为悬停和焦点。"},
			{name: "positionStyle",type: "string",default: "absolute",des: "CSS位置的类型。"},
			{name: "tooltipDisabled",type: "boolean",default: "null",des: "当存在时，它指定应该禁用组件。"},
			{name: "appendTo",type: "string",default: "any",des: "目标元素附加覆盖，有效值是'体、'目标或'A'。"},
			{name: "hideDelay",type: "null",default: "number",des: "延迟以毫秒隐藏工具提示。"},
			{name: "showDelay",type: "null",default: "number ",des: "延迟以毫秒显示工具提示。"},
			{name: "life",type: "string",default: "null ",des: "时间在毫秒内等待，即使它是活动的，也可以隐藏工具提示。"},
			{name: "tooltipStyleClass",type: "string",default: "null ",des: "工具提示的样式类。"},
			{name: "escape",type: "boolean",default: "true ",des: "默认情况下，工具提示内容呈现为文本。设置为假以支持。"},
			{name: "tooltipZIndex",type: "string",default: "auto ",des: "z-index是否应自动管理以始终保持在顶部或一个固定的值。"}
		];

		this.headers = [
			{name : "名字"},
			{name : "类型"},
			{name : "默认"},
			{name : "描述"}
		];

		

		this.styleHeader = [
			{name : "名字"},
			{name : "元素"}
		];

		this.styleValue = [
			{name : "ui-tooltip",el : "容器元素"},
			{name : "ui-tooltip-arrow",el : "工具提示箭头"},
			{name : "ui-tooltip-text",el : "工具提示文本"}
		];
	}

}



// WEBPACK FOOTER //
// ./src/app/view/tooltip/tooltip.component.ts